import React from 'react'
import SuperUserPageSF from '../../templates/SuperUserPageSF.js'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import LRTableBodyUI from "../../widgets/layout/LRTableBodyUI";
import LRTableRowUI from "../../widgets/layout/LRTableRowUI";
import {Link} from "react-router-dom";
import MessageUtils from "../../util/MessageUtils";
import PageTitleUI from "../../widgets/output/PageTitleUI";
import LoanSubTabSF from "../../components/superUser/loan/LoanSubTabSF";
import EmptyListUI from "../../widgets/output/EmptyListUI";

const LeegalityAccountMappingListPageUI = ({context, errorList, leegalityDocList, messageList}) =>

  <SuperUserPageSF context={context} className='pg_su_acc'
                   headerText='Loans' centered={false}
  >
    <PageTitleUI context={context} titleText={MessageUtils.getMessageValue(messageList, "c_loans")}/>
    <LoanSubTabSF messageList={messageList} context={context} tabSelected={"leegality_mappings"}/>
    {
      !leegalityDocList && !errorList &&
      <SpinnerComponentUI/>
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]}/>
    }
    {
      leegalityDocList && leegalityDocList.length === 0 &&
      <EmptyListUI
        context={context}
        messageList={messageList}
        createEnabled={false}
        createDisabledMessageKey='c_no_leegality_mappings_msg'
      />
    }
    {
      leegalityDocList && leegalityDocList.length !== 0 &&
      <>Leeagality Docs available</>
      // <LoanListUI context={context} loanList={leegalityDocList}/>
    }
  </SuperUserPageSF>


const LoanListUI = ({context, loanList, onClick}) =>
  <div className='su_loans'>
    <table className={"table table-striped"}>
      <tbody>
      {
        loanList.map((loan, i) =>
          <LoanRowUI key={i} context={context} loan={loan} />
        )
      }
      </tbody>
    </table>

  </div>

const numberFormat = (value) =>
  new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR'
  }).format(value);

const LoanRowUI = ({context, loan}) =>
  <tr>
    <td>
      {
        loan.subStatus !== "VERT_REVIEW" &&
        <Link to={"/su/loan/" + loan.accountId + "/" + loan.loanId}>{MessageUtils.truncate(loan.purposeOfLoanName, 50)}</Link>
      }
      {
        loan.subStatus === "VERT_REVIEW" && loan.status === "REQUESTED" &&
        <Link to={"/su/loan/" + loan.accountId + "/requested/vertReview/" + loan.loanId}>{MessageUtils.truncate(loan.purposeOfLoanName, 50)}</Link>
      }
      {
        loan.subStatus === "VERT_REVIEW" && loan.status === "INITIAL" &&
        <Link to={"/su/loan/" + loan.accountId + "/initial/vertReview/" + loan.loanId}>{MessageUtils.truncate(loan.purposeOfLoanName, 50)}</Link>
      }
      {
        loan.subStatus === "VERT_REVIEW" && loan.status === "FINAL_OFFER" &&
        <Link to={"/su/loan/" + loan.accountId + "/final/vertReview/" + loan.loanId}>{MessageUtils.truncate(loan.purposeOfLoanName, 50)}</Link>
      }
    </td>
    <td>{loan.status}</td>
    <td>{loan.subStatus}</td>
    <td>{numberFormat(loan.loanAmountRequested)}</td>
    <td>{loan.loanTenureMonthRequested}</td>
  </tr>



export default LeegalityAccountMappingListPageUI
